const baseURL = '';
const bucket = 'rcmtoss'
const officeServeUrl = 'https://view.officeapps.live.com/op/view.aspx'
const pdfServeUrl = 'https://new.test.manage.bjsihao.cn/webPublic/pdf/web/viewer.html'  

// envType 对应的值  local dev test prod
const envType = process.env.VUE_APP_SERVER_ENV
const yyySetType = 1
const yyyNum = "6004000001"
const proxyPubUrl = "http://public.bjsihao.cn/"
let proxyUrl, socketUrl, pathName, curEnvType, uploadImgToTeacherFollowUrl;  //
switch(envType){
    case 'test':
        proxyUrl = "http://101.200.212.33:8765/"
        proxyUrl = "https://new.test.manage.bjsihao.cn/"
        socketUrl = "https://socket.liusandao.top"
        socketUrl = ""
        uploadImgToTeacherFollowUrl = "https://new.test.manage.bjsihao.cn/webMobile/#/fileUploadToTeacherFollow"
        pathName = "sockettest"
        curEnvType = 12
        break
    case "dev":
        proxyUrl = "http://101.200.212.33:8764/"
        proxyUrl = "http://new.1.test.manage.bjsihao.cn/"
        //proxyUrl = "http://192.168.1.73:8764"
        //proxyUrl = 'http://192.168.1.13:8764/'
        //socketUrl = "https://socket.liusandao.top"
        //socketUrl = "http://localhost:3008"
        //socketUrl = ""
        uploadImgToTeacherFollowUrl = "http://new.1.test.manage.bjsihao.cn/webMobile/#/fileUploadToTeacherFollow"
        pathName = "socketdev"
        curEnvType = 13
        break
    case 'local':
        proxyUrl = "http://101.200.212.33:8764/"
        //proxyUrl = "http://192.168.1.138:8764"
        proxyUrl = "http://new.1.test.manage.bjsihao.cn/"
        socketUrl = "http://39.98.157.218:3008"
        socketUrl = ""
        uploadImgToTeacherFollowUrl = "http://new.1.test.manage.bjsihao.cn/webMobile/#/fileUploadToTeacherFollow"
        pathName = "socketdev"
        curEnvType = 13
        break
    case 'prod':
        proxyUrl = 'http://101.200.212.33:8766/'
        proxyUrl = "https://v1.manage.bjsihao.cn/"
        //proxyUrl = "https://v1.manage.bjsihao.cn/"
        socketUrl = "https://socket.liusandao.top"
        socketUrl = ""
        uploadImgToTeacherFollowUrl = "https://v1.manage.bjsihao.cn/webMobile/#/fileUploadToTeacherFollow"
        pathName = "socketprod"
        curEnvType = 11
        break
}
module.exports = {
    baseURL,
    bucket,
    officeServeUrl,
    pdfServeUrl,
    envType,
    proxyUrl,
    proxyPubUrl,
    socketUrl,
    pathName,
    yyySetType,
    yyyNum,
    ossUrl: "https://rcmtoss.oss-cn-beijing.aliyuncs.com",
    parentDefaultImg: "https://rcmtoss.oss-cn-beijing.aliyuncs.com/default/parentDefault.png",
    studentDefaultImg: "https://rcmtoss.oss-cn-beijing.aliyuncs.com/default/studentDefault.png",
    teacherDefaultImg: "https://rcmtoss.oss-cn-beijing.aliyuncs.com/default/teacherDefault.png",
    eduDefaultImg: "https://rcmtoss.oss-cn-beijing.aliyuncs.com/default/teacherManagerDefault.png",
    fileLearnDefaultCover: "https://rcmtoss.oss-cn-beijing.aliyuncs.com/default/file-learn-cover.png",
    videoLearnDefaultCover: "https://rcmtoss.oss-cn-beijing.aliyuncs.com/default/video-learn-cover.png",
    curEnvType,
    uploadImgToTeacherFollowUrl,
}